import { render } from "./RightContent.vue?vue&type=template&id=655440b0&scoped=true"
import script from "./RightContent.vue?vue&type=script&lang=js"
export * from "./RightContent.vue?vue&type=script&lang=js"

import "./RightContent.vue?vue&type=style&index=0&id=655440b0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655440b0"]])

export default __exports__